import { createContext, useContext, ReactNode } from "react";
import useQuickFilters from "../hooks/quick-filters";

type QuickFiltersContextType = ReturnType<typeof useQuickFilters>;

const QuickFiltersContext = createContext<QuickFiltersContextType | undefined>(undefined);

export const QuickFiltersProvider = ({ children }: { children: ReactNode }) => {
  const quickFilters = useQuickFilters({ autoFetch: true });

  console.log('quickFilters = ', quickFilters);

  return (
    <QuickFiltersContext.Provider value={quickFilters}>
      {children}
    </QuickFiltersContext.Provider>
  );
};

export const useQuickFiltersContext = () => {
  const context = useContext(QuickFiltersContext);

  console.log('context = ', context);
  if (!context) {
    throw new Error("useQuickFiltersContext must be used within a QuickFiltersProvider");
  }
  return context;
};
